import SvgIcon, { IconProps } from './SvgIcon';
import React from 'react';

export default function SmileyIcon(props: IconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z" />
      <path d="M8 15a5 5 0 0 0 8 0" />
      <path strokeWidth="2" d="M8 9h0m8 0h0" />
    </SvgIcon>
  );
}
